import React, { PureComponent, ReactNode } from 'react';
import b from 'b_';

import Theme from '@interfaces/themes';

import './theme-header.css';

interface Props {
    theme: Theme;
    className?: string;
    children?: ReactNode;
}

const class_ = b.with('theme-header');
const headerClass = class_();

export default class ThemeHeader extends PureComponent<Props> {
    public render() {
        const { theme, children, className = '' } = this.props;

        if (!theme) {
            return null;
        }

        const { title, description, image = '/no-record.png' } = theme || ({} as any);
        const rootClass = `${headerClass} ${className}`;

        return (
            <div
                className={rootClass}
                style={{ backgroundImage: `url(${image})` }}
            >
                <h1 className={class_('title')}>
                    {title}
                </h1>
                {description && (
                    <div className={class_('description')}>{description}</div>
                )}
                {children}
            </div>
        );
    }
}
